import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EntityCard } from "@/components/ui/entity-card";
import { Skeleton } from "@/components/ui/skeleton";
import type { Department, Shift, User } from "../../../api";
import operator from "../../../images/operator.png";
import { useTranslation } from "react-i18next";

export type OperatorDetailsProps = {
    user?: User;
    department?: Department;
    shift?: Shift;
    badgeLabel: string;
    title: string;
    /** Sometimes we do not know the user. E.g., we do not know the user of a pedestrian badge. */
    unknown: boolean;
    loading?: boolean;
};

export const OperatorDetails = ({
    user,
    department,
    shift,
    badgeLabel,
    title,
    unknown,
    loading,
}: OperatorDetailsProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
                <EntityCard
                    user={user}
                    unknown={unknown}
                    loading={loading}
                    badgeLabel={badgeLabel}
                    image={unknown ? operator : undefined}
                />
                {/** Only display user information if we actually have an existing user. */}
                {user && (
                    <>
                        <div className="flex justify-between">
                            <div className="text-muted-foreground">{t("schema.user.shift")}</div>
                            <div>
                                {shift?.label && !loading && shift.label}
                                {loading && <Skeleton className="h-full w-24" />}
                            </div>
                        </div>
                        <div className="flex justify-between">
                            <div className="text-muted-foreground">
                                {t("schema.user.department")}
                            </div>
                            <div>
                                {department?.label && !loading && department.label}
                                {loading && <Skeleton className="h-full w-32" />}
                            </div>
                        </div>
                    </>
                )}
            </CardContent>
        </>
    );
};
